import { request } from '@skillarea/lib-shared';

import {
  getCapacitorPlatform,
  isCapacitorNativePlatform,
} from '~/lib/mobile/capacitor-bridge';
import { ensureDeviceId, getCachedDeviceId } from '~/lib/security/device-id';
import { serviceOptions } from '~/services';
import { errorToastInterceptor } from '~/stores/interceptors/errorToastInterceptor';
import { unauthorizedInterceptor } from '~/stores/interceptors/unauthorizedInterceptor';

export const initServiceOptions = () => {
  if (typeof window === 'undefined') {
    serviceOptions.basePath =
      process.env.SSR_BASE_URL ||
      process.env.SERVER_API_TARGET ||
      `http://localhost:${process.env.HTTP_PORT || '3001'}`;
  } else {
    const baseUrlFromEnv = import.meta.env.VITE_MOBILE_API_URL?.trim();
    const isNative = isCapacitorNativePlatform();

    if (baseUrlFromEnv && isNative) {
      serviceOptions.basePath = baseUrlFromEnv;
    } else if (isNative && window.location.protocol === 'file:') {
      const port = import.meta.env.VITE_HTTP_PORT || '3001';
      const platform = getCapacitorPlatform();
      const host =
        platform === 'android'
          ? '10.0.2.2'
          : platform === 'ios'
            ? 'localhost'
            : 'localhost';

      serviceOptions.basePath = `http://${host}:${port}`;
    } else {
      serviceOptions.basePath = process.env.BASE_URL || '';
    }
  }

  serviceOptions.axios = {
    request: request(
      { withCredentials: true },
      [unauthorizedInterceptor, errorToastInterceptor],
      {
        deviceIdProvider: getCachedDeviceId,
        deviceIdHeaderName: 'X-Device-Id',
      },
    ),
  };

  serviceOptions.showError = true;

  if (typeof window !== 'undefined') {
    void ensureDeviceId();
  }
};
